import { AssetTypes } from 'sigma-mappings';
import GeneralTab from '@/domain/components/generalPanel/reports/additionalFields/modal/GeneralTab';
import TransformerTab from '@/domain/components/generalPanel/reports/additionalFields/modal/TransformerTab';
import DisconnectorTab from '@/domain/components/generalPanel/reports/additionalFields/modal/DisconnectorTab';
import CircuitBreakerTab from '@/domain/components/generalPanel/reports/additionalFields/modal/CircuitBreakerTab';

export default vm => ([
  {
    name: 'general',
    component: GeneralTab,
    title: vm.$t('general.general'),
  },
  {
    name: AssetTypes.TRANSFORMER,
    component: TransformerTab,
    title: vm.$t('enums.asset-info.asset-type.transformer'),
  },
  {
    name: AssetTypes.CIRCUIT_BREAKER,
    component: CircuitBreakerTab,
    title: vm.$t('enums.asset-info.asset-type.circuit-breaker'),
  },
  {
    name: AssetTypes.DISCONNECTOR,
    component: DisconnectorTab,
    title: vm.$t('enums.asset-info.asset-type.disconnector'),
  },
]);
